import styled from "styled-components";

const BodyContainer = styled.div`
  flex: 5 0;
  width: 100%;
  overflow-y: auto;
  display: flex;

  @media (max-width: 480px) {
    flex: 5 0;
    width: 80%;
    overflow-y: auto;
    padding-left: 10%;
    padding-right: 10%;
  }
`;

export default BodyContainer;
